import { BucketView } from "@/modules/storage/bucket/BucketView.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/_main/storage/bucket/$storageName/")({
    component: Component,
});

function Component() {
    const { storageName } = Route.useParams();
    return <BucketView key={storageName} storageName={storageName} />;
}
